import axios from "axios";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

export const getAudioCategories = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/audio-categories`);
        return response.data;
    } catch (error) {
        console.error("Error fetching audio categories:", error.response?.data || error.message);
        throw error;
    }
};

export const createAudioCategory = async (categoryData) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}/audio-categories`,
            categoryData,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );

        return response.data;
    } catch (error) {
        console.error("Error creating audio category:", error.response?.data || error.message);
        throw error;
    }
};